import {createApp} from 'vue'
import options from './MitIdLogout.options'

const el = '.kb-component--mit-id-logout'

export default function(Store){
    const DOM = document.querySelector(el)

    if(DOM){
        const template = DOM.outerHTML
        options.template = template
        const component = createApp(options).use(Store)
        component.mount(DOM)
    }
}

